import { nextDays, periodTitle } from 'App/Map/PanelDetails/OverviewCharts/_utils/columnTitles'
import type { TValueGroupColumns } from 'App/Map/PanelDetails/OverviewCharts/_utils/types'
import { valueColumn } from 'App/Map/PanelDetails/OverviewCharts/_utils/valueColumn'
import { translate } from 'i18n/i18n'
import { unitConverter } from 'utils/unitConverter/unitConverter'

const alternariaColumn = (dataIndex: string, label: string, period: string, width: number) =>
  valueColumn({ dataIndex, title: periodTitle(label, period), width, converter: unitConverter.alternaria })

const fireBlightColumn = (dataIndex: string, label: string, period: string, width: number) =>
  valueColumn({ dataIndex, title: periodTitle(label, period), width, converter: unitConverter.fireBlight })

export const diseasesColumns: Record<string, TValueGroupColumns> = {
  alternaria: {
    leadingColumn: 'blockName',
    getColumns: () => {
      const dsv = translate.phrases.banyanApp('7 Day DSV')
      const maxDsv = translate.phrases.banyanApp('Max 7 Day DSV')
      const yesterday = translate.phrases.banyanApp('Yesterday')
      const today = translate.phrases.banyanApp('Today')
      const tomorrow = translate.phrases.banyanApp('Tomorrow')

      return [
        alternariaColumn('alternariaCumulativeRolling7Days_yesterday_dsv', dsv, yesterday, 200),
        alternariaColumn('alternariaCumulativeRolling7Days_today_dsv', dsv, today, 200),
        alternariaColumn('alternariaCumulativeRolling7Days_tomorrow_dsv', dsv, tomorrow, 200),
        alternariaColumn('alternariaCumulativeRolling7Days_next7DaysMax_dsv', maxDsv, nextDays(7), 250),
        alternariaColumn('alternariaCumulativeRolling7Days_next14DaysMax_dsv', maxDsv, nextDays(14), 250),
      ]
    },
  },
  fire_blight: {
    leadingColumn: 'blockName',
    getColumns: () => {
      const trv = translate.phrases.banyanApp('TRV')
      const maxTrv = translate.phrases.banyanApp('Max TRV')
      const yesterday = translate.phrases.banyanApp('Yesterday')
      const current = translate.phrases.banyanApp('Current')
      const tomorrow = translate.phrases.banyanApp('Tomorrow')

      return [
        fireBlightColumn('fireBlight_yesterday_trv', maxTrv, yesterday, 200),
        fireBlightColumn('fireBlight_today_trv', trv, current, 200),
        fireBlightColumn('fireBlight_tomorrow_trv', maxTrv, tomorrow, 200),
        fireBlightColumn('fireBlight_next7DaysMax_trv', maxTrv, nextDays(7), 250),
        fireBlightColumn('fireBlight_next14DaysMax_trv', maxTrv, nextDays(14), 250),
      ]
    },
  },
}
